import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  AfterViewChecked
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import {UserService} from '../../../core/services/user.service';
import { FirebaseService } from 'src/app/core/services/firebase.service';

interface Comment {
  id: string,
  owner: string,
  ownerId?: string,
  value: string,
  user: { firstName: string, lastName: string; profileImage?: string };
  isOwner: boolean,
  toOldToDelete: boolean,
  createdAt: Date
}

@Component({
  selector: 'app-in-details-comments',
  templateUrl: './in-details-comments.component.html',
  styleUrls: ['./in-details-comments.component.scss']
})
export class InDetailsCommentsComponent implements OnInit, OnChanges, AfterViewInit, AfterViewChecked {

  commentForm: FormGroup;
  comments: Comment[] = [];
  loggedUserId: string;

  private scrollContainer: any;
  profilePictureUrl: string | null = null;
  @Output() submitEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  @Input() itemDetails;

  @ViewChild('scrollframe', {static: false}) scrollFrame: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private firebaseService: FirebaseService
  ) { }

  ngOnInit(): void {
    this.buildLoginForm();
    this.loggedUserId = this.userService.getLoggedUser().id;
    this.getUserProfileImage(this.loggedUserId);
  }

  ngOnChanges(): void {
    const comments = this.itemDetails.comments || [];
    this.comments = comments.map(a => ({
      ...a,
      isOwner: ( a.owner || a.ownerId ) === this.loggedUserId,
      toOldToDelete: moment().diff(a.createdAt, 'hours') >= 48
    }));

    const usersMap = new Map<string, Comment[]>();
    this.comments.forEach(comment => {
      const ownerId = comment.owner || comment.ownerId;
      if (ownerId) {
        if (!usersMap.has(ownerId)) {
          usersMap.set(ownerId, [comment]);
        } else {
          usersMap.get(ownerId).push(comment);
        }
      }
    });

    if (usersMap.size) {
      const entries = Array.from(usersMap.entries());
      Promise.all(entries.map(([owner, comments]) =>
        this.getCommentOwnerProfileImage(owner, comments)
      ));
    }
  }

  ngAfterViewInit() {
    this.scrollContainer = this.scrollFrame.nativeElement;
  }
  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom() {
    this.scrollContainer.scroll({
      top: this.scrollContainer.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

  buildLoginForm() {
    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.required],
    });
  }

  formatDate(date) {
    date = moment(date).format('DD/MM/YYYY - HH:mm');
    date = date.replace(':', 'h');
    return date;
  }

  delete(id) {
    this.deleteEvent.emit(id);
  }

  submit() {
    if (this.commentForm.valid) {
      const formValue = this.commentForm.getRawValue();
      this.submitEvent.emit(formValue);
      this.commentForm.controls.comment.setValue('');
    }
  }

  async getCommentOwnerProfileImage(owner, comments) {
    const url = await this.firebaseService.getUserPicture(owner);
    comments.forEach(c => {
      c.user.profileImage = url;
    });
  }

  async getUserProfileImage(userId: string) {
    this.profilePictureUrl = await this.firebaseService.getUserPicture(userId);
  }

}
